var _defs, _rect, _rect2, _path, _polygon, _path2, _ellipse, _path3, _path4, _rect3, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 323.27 196.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#fd0c73;}.cls-3{fill:#2367b7;}.cls-4{fill:#33d4ff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 6.13,
    y: 2.9,
    width: 311,
    height: 190.54,
    rx: 13.35,
    ry: 13.35
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.02,
    y: 20.66,
    width: 273.22,
    height: 155.03
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m142.14,114.43h42.97c18.96,0,34.36,15.4,34.36,34.36v26.9h-111.69v-26.9c0-18.96,15.4-34.36,34.36-34.36Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "185.41 110.03 179.37 111.22 147.88 110.87 135.21 82.58 189.94 81.69 185.41 110.03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m147.88,118.11v-17.64h31.5v17.64s-15.11,8.62-31.5,0Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 162.99,
    cy: 75.48,
    rx: 25.38,
    ry: 31.68
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m162.99,109.17c-15.1,0-27.38-15.11-27.38-33.68s12.28-33.68,27.38-33.68,27.38,15.11,27.38,33.68-12.28,33.68-27.38,33.68Zm0-63.37c-12.89,0-23.38,13.32-23.38,29.68s10.49,29.68,23.38,29.68,23.38-13.32,23.38-29.68-10.49-29.68-23.38-29.68Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m173.35,48.03s.03-.05.08-.13c1.07,8.36,7.54,19.27,12.2,23.5,4.88,32.43-6.25,39.81-6.25,39.81,16.63,2.57,24.25-2.11,24.25-2.11-6.96-9.56-8.05-13.84-6.2-32.34,1.2-12.01-3.7-28.14-12.87-33.66-2.26-1.69-3.97-1.69-3.97-1.69,0,0-14.39-16.76-38-1.95-2.3,1.45-4.31,3.23-6.04,5.32.05.02.11.03.17.04-4.67,5.11-7.2,11.86-8.55,18.14-.97,4.54-1.27,9.18-1.09,13.81.39,9.91.29,24.96-4.1,31.92,9.15,2.05,14.65,3.3,24.91,2.18,0,0-4.86-13.2-8.03-22.39-3.09-8.93-2.15-14.38-2.15-14.38,4.68-2.51,13.47-5.51,18.39-9.11,7.21-5.27,13.39-12.07,17.26-16.96Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.61,
    y: 132.23,
    width: 239.11,
    height: 32.82
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m59.99,156.63l3.23-2.4c.93,1.73,2.18,2.46,3.52,2.46,2.08,0,3.17-1.12,3.17-4.38v-15.68h4.74v16.06c0,4.45-2.24,8.1-7.33,8.1-3.46,0-5.76-1.41-7.33-4.16Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m79.76,153.62v-11.2h4.7v10.59c0,2.75.77,3.74,2.5,3.74,1.47,0,2.43-.64,3.65-2.24v-12.1h4.7v17.92h-3.84l-.35-2.56h-.13c-1.54,1.82-3.26,3.01-5.7,3.01-3.87,0-5.54-2.69-5.54-7.17Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m98.64,158.26l2.14-2.94c1.6,1.25,3.14,1.95,4.8,1.95,1.79,0,2.59-.77,2.59-1.89,0-1.34-1.86-1.95-3.74-2.69-2.27-.86-4.8-2.24-4.8-5.25,0-3.2,2.59-5.47,6.69-5.47,2.59,0,4.61,1.09,6.08,2.21l-2.11,2.85c-1.28-.93-2.53-1.54-3.84-1.54-1.63,0-2.4.7-2.4,1.73,0,1.31,1.66,1.79,3.55,2.5,2.37.9,4.99,2.08,4.99,5.41,0,3.14-2.46,5.66-7.14,5.66-2.4,0-5.02-1.06-6.82-2.53Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m116.11,154.07v-7.94h-2.53v-3.49l2.78-.22.54-4.83h3.9v4.83h4.42v3.71h-4.42v7.94c0,2.05.83,3.01,2.43,3.01.58,0,1.28-.19,1.76-.38l.77,3.42c-.96.32-2.21.67-3.78.67-4.26,0-5.89-2.72-5.89-6.72Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m135.25,155.48c0-3.84,3.1-5.86,10.34-6.62-.1-1.76-.86-3.1-3.07-3.1-1.66,0-3.26.74-4.93,1.7l-1.7-3.1c2.11-1.31,4.67-2.37,7.49-2.37,4.54,0,6.88,2.72,6.88,7.9v10.46h-3.84l-.32-1.92h-.13c-1.57,1.34-3.36,2.37-5.41,2.37-3.2,0-5.31-2.27-5.31-5.31Zm10.34-.13v-3.62c-4.38.54-5.86,1.76-5.86,3.36,0,1.41.99,2.02,2.37,2.02s2.34-.64,3.49-1.76Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m167.41,140.6h-6.66v-3.97h18.11v3.97h-6.72v19.74h-4.74v-19.74Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m181.94,136.95c0-1.54,1.12-2.56,2.75-2.56s2.72,1.02,2.72,2.56-1.12,2.59-2.72,2.59-2.75-1.02-2.75-2.59Zm.38,5.47h4.7v17.92h-4.7v-17.92Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m190.93,151.38c0-5.95,4.29-9.41,9.15-9.41,2.21,0,3.9.86,5.22,1.98l-2.24,3.04c-.9-.77-1.73-1.18-2.72-1.18-2.75,0-4.61,2.21-4.61,5.57s1.89,5.57,4.45,5.57c1.28,0,2.5-.61,3.49-1.44l1.89,3.1c-1.73,1.5-3.9,2.18-5.89,2.18-4.96,0-8.74-3.46-8.74-9.41Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m208.91,134.81h4.64v15.33h.13l6.11-7.71h5.15l-6.14,7.39,6.72,10.53h-5.09l-4.35-7.42-2.53,2.88v4.54h-4.64v-25.53Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m226.22,151.38c0-5.79,4.1-9.41,8.35-9.41,4.93,0,7.49,3.62,7.49,8.54,0,.9-.1,1.76-.22,2.18h-11.04c.38,2.94,2.3,4.48,4.96,4.48,1.47,0,2.75-.45,4.03-1.25l1.6,2.88c-1.76,1.22-4.03,1.98-6.24,1.98-5.02,0-8.93-3.49-8.93-9.41Zm11.81-1.82c0-2.4-1.09-3.94-3.39-3.94-1.89,0-3.55,1.34-3.9,3.94h7.3Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m245.94,142.42h3.84l.35,3.17h.1c1.31-2.34,3.23-3.62,5.09-3.62.99,0,1.57.16,2.11.38l-.8,4.06c-.64-.19-1.15-.29-1.89-.29-1.41,0-3.1.93-4.1,3.52v10.69h-4.7v-17.92Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bf01ab78559084510880d6eaa7754a50.svg";
export { ForwardRef as ReactComponent };